import { Alert, Button, Card, Checkbox, Form, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AccountBean, NotificationSettingBean } from 'src/api/api'
import { enumView } from 'src/util/Util'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'
import notificationSettingApi from './NotificationSettingApi'

const FormItem = Form.Item
const Option = Select.Option

const formInfoItems: FormDataType[] = [
    FormDataType.Accounts
]

const NotificationSettingEdit = () => {

    const [info, setInfo] = useState({
        accounts: []
    })

    const navigateTo = useNavigate()
    const { id } = useParams<{ id: string }>()
    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await notificationSettingApi.edit(id, values)
            navigateTo('/notification-setting')
        } catch (e) {
            setError(e.error)
        }
    }

    const loadData = async () => {
        try {
            const response = await notificationSettingApi.view(id)
            form.setFieldsValue(response.data)

            const formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [id])

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="Notification Setting" size="small" className="form-card">
            <FormItem
                required
                name="type"
                label="Type"
                rules={[{ required: true, message: 'Notification type required' }]}
            >
                <Select placeholder="Select Type" disabled>
                    {Object.values(NotificationSettingBean.TypeEnum).map(type => <Option key={type} value={type}>{enumView(type).replace('SSPTraffic', 'SSP Traffic')}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="accountIds"
                label="Accounts"
            >
                <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    placeholder="Select Accounts"
                >
                    {info.accounts.map((item: AccountBean) => <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="enabled"
                label="Enabled"
                valuePropName="checked"
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/notification-setting')}>Cancel</Button>
        </div>
    </Form>
}

export default NotificationSettingEdit



// WEBPACK FOOTER //
// ./src/component/app/notificationSetting/NotificationSettingEdit.tsx